// src/com/bulk_company/BulkCompanyGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * BULK_COMPANY Apollo Graphql
 * Bulk Company
 * Project: NewTOP for cloud
 * 2026-05-13 15:53:59 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const BULK_COMPANY_LIST_PART = gql`
fragment BulkCompanyListPart on BulkCompany {
    bulkCompanyId
    comName
    useYn
    regDate
    regUser
    updatedDate
    updatedUser
    regUserName
}
`;

/* const BULK_COMPANY_NO_LIST_PART = gql`
fragment BulkCompanyNoListPart on BulkCompany {
}
`; */

// bulkCompanyList: [BulkCompany]!
export const LIST_BULK_COMPANY = gql`
${BULK_COMPANY_LIST_PART}
query ListBulkCompany {
    bulkCompanyList {
        ...BulkCompanyListPart
    }
}
`;

export const GET_BULK_COMPANY = gql`
${BULK_COMPANY_LIST_PART}
query GetBulkCompany($bulkCompanyId:Int!) {
    bulkCompanyItem(bulkCompanyId:$bulkCompanyId) {
        ...BulkCompanyListPart
    }
}
`;

export const ADD_BULK_COMPANY = gql`
mutation AddBulkCompany($bulkCompany:InputBulkCompanyAdd!) {
	bulkCompanyAdd(bulkCompany: $bulkCompany) {
		ok
		message
	}
}
`;

export const EDIT_BULK_COMPANY = gql`
mutation EditBulkCompany($bulkCompany:InputBulkCompanyEdit!) {
	bulkCompanyEdit(bulkCompany: $bulkCompany) {
		ok
		message
	}
}
`;

export const REMOVE_BULK_COMPANY = gql`
mutation RemoveBulkCompany($bulkCompany:InputBulkCompanyRemove!) {
	bulkCompanyRemove(bulkCompany: $bulkCompany) {
		ok
		message
	}
}
`;

export const SET_USAGE_BULK_COMPANY = gql`
mutation SetUsageBulkCompany($bulkCompany:InputBulkCompanySetUsage!) {
	bulkCompanySetUsage(bulkCompany: $bulkCompany) {
		ok
		message
	}
}
`;
